import React from "react";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  DialogContent,
  DialogContentText,
  Button,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import storePersist, { localConstant } from "../../services/localStorage";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../utils/snackbarConfig";
import moment from "moment";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const Alert = ({
  isOpen,
  reset,
  handleCancel = reset,
  handleGateOpen,
  item,
  gate,
  displayEsignSignNow = true,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deadlineUTC = moment.utc("2025-06-01T14:59:59Z");
  const isBeforeDeadline = moment.utc().isSameOrBefore(deadlineUTC);
  const userType = storePersist.get(localConstant.USER_PROFILE);
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        reset();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Box display="flex" alignItems="center" gap="10px">
          <WarningAmberIcon style={{ color: "red" }} />
          <Typography
            style={{
              fontFamily: "Segoe UI",
              fontSize: 20,
              fontWeight: 600,
              textAlign: "left",
              color: "red",
            }}
          >
            {isBeforeDeadline
              ? t("pages.esignVerification.title01")
              : t("pages.esignVerification.title02")}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{
            fontFamily: "Segoe UI",
            fontSize: 18,
            fontWeight: 400,
            textAlign: "left",
          }}
          dangerouslySetInnerHTML={{
            __html:
              userType === "OWNER"
                ? isBeforeDeadline
                  ? t("pages.esignVerification.text03")
                  : t("pages.esignVerification.text07")
                : isBeforeDeadline
                  ? t("pages.esignVerification.text05")
                  : t("pages.esignVerification.text09"),
          }}
        />
        <DialogContentText
          id="alert-dialog-description"
          style={{
            fontFamily: "Segoe UI",
            fontSize: 18,
            fontWeight: 400,
            textAlign: "left",
          }}
        >
          {userType === "OWNER"
            ? isBeforeDeadline
              ? t("pages.esignVerification.text04")
              : t("pages.esignVerification.text08")
            : isBeforeDeadline
              ? t("pages.esignVerification.text06")
              : t("pages.esignVerification.text06")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {displayEsignSignNow && (
          <Button
            variant="outlined"
            style={{
              alignSelf: "center",
              width: 120,
              height: 32,
              marginLeft: 21,
              marginBottom: 3,
              display: "flex",
              borderRadius: 4,
            }}
            onClick={() => {
              if (
                storePersist.get(localConstant.AGREEMENT_STATUS) === "DECLINED"
              ) {
                enqueueSnackbar(
                  "Esign Agreement was declined. Please try again after some time while a new agreement is being created !",
                  SnackbarConfig.error,
                );
              } else navigate("/adobeDocument");
            }}
          >
            <Typography variant="buttonText" color="common.buttonText">
              {t("pages.ownerDashboard.text02")}
            </Typography>
          </Button>
        )}
        {isBeforeDeadline && (
          <Button
            variant="outlined"
            style={{
              alignSelf: "center",
              width: 120,
              height: 32,
              marginLeft: 21,
              marginBottom: 3,
              display: "flex",
              borderRadius: 4,
            }}
            onClick={() => {
              handleGateOpen(item, gate);
              handleCancel && handleCancel();
              reset();
            }}
          >
            <Typography variant="buttonText" color="common.buttonText">
              {t("pages.esignVerification.text10")}
            </Typography>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default Alert;
